// Lib
import { isUndefined } from 'lodash/fp';

// Utils
import { getBackgroundColor, getShowGrid } from '../../../common/elements/utils/elementPropertyUtils';
import { getUserShowGrid } from '../../../common/users/utils/userPropertyUtils';
import { isHexColorFormat } from '../../../common/colors/colorSpaceUtil';

// Constants
import { CANVAS_COLORS } from '../../../common/colors/colorConstants';

// Either returns the hex code of the colour or the CSS custom property variable reference
export const getBackgroundColorCssValue = (element) => {
    const backgroundColor = getBackgroundColor(element);

    if (!backgroundColor) return backgroundColor;

    return isHexColorFormat(backgroundColor)
        ? backgroundColor
        : CANVAS_COLORS[backgroundColor] && CANVAS_COLORS[backgroundColor].css;
};

export const getIsCustomBackgroundColor = (element) => {
    const backgroundColor = getBackgroundColor(element);

    if (!backgroundColor) return false;

    return isHexColorFormat(backgroundColor);
};

export const getShowBoardGrid = (element, user) => {
    const boardGridSetting = getShowGrid(element);

    if (!isUndefined(boardGridSetting)) return boardGridSetting;

    const userGridPreference = getUserShowGrid(user);
    return userGridPreference !== false;
};

export const getIsDefaultBackground = (element, user) => {
    const showGridByDefault = getUserShowGrid(user) !== false;
    return getShowBoardGrid(element, user) === showGridByDefault && !getBackgroundColor(element);
};
